export default function frontlineBuildInfo() {
  function frontlineMeta(name: string) {
    const meta: any = document.querySelector(`meta[name="frontline:${name}"]`);

    if (!meta) {
      return '';
    }

    return meta.content;
  }

  (window as any).FRONTLINE = {
    revision: frontlineMeta('revision'),
    branch: frontlineMeta('branch'),
    experiment: frontlineMeta('experiment'),
  };

  // eslint-disable-next-line
  console.log((window as any).FRONTLINE);
}
